import type { SelectionActions, SliceCreator } from './types';

export const createSelectionSlice: SliceCreator<SelectionActions> = (set) => ({
  toggleBlockSelection: (toolCallId, id) =>
    set((s) => {
      const current = s.selectionByBlock[toolCallId] ?? [];
      const next = current.includes(id)
        ? current.filter((x) => x !== id)
        : [...current, id];
      return {
        selectionByBlock: { ...s.selectionByBlock, [toolCallId]: next },
      };
    }),

  setBlockSelection: (toolCallId, ids) =>
    set((s) => ({
      selectionByBlock: { ...s.selectionByBlock, [toolCallId]: ids },
    })),

  clearBlockSelection: (toolCallId) =>
    set((s) => {
      const { [toolCallId]: _drop, ...rest } = s.selectionByBlock;
      return { selectionByBlock: rest };
    }),
});
